var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",on:{"click":_vm.toggleFull}},[_c('span',[_vm._v("全屏")]),_c('i',{staticClass:"el-icon-full-screen sty"})])
}
var staticRenderFns = []

export { render, staticRenderFns }